"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabasesDisplayGrid = exports.databasesWithCrassCellFormatters = exports.columnsForVizPortal = exports.columns = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var Localize_1 = require("@tableau/widgets/lib/gen-src/Localize");
var React = require("react");
var Localize_2 = require("../../../gen-src/Localize");
var GroupPaperclip_1 = require("../../../gen-src/icons/GroupPaperclip");
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
var ObfuscatedCellFormatter_1 = require("../datagrid/cellFormatters/ObfuscatedCellFormatter");
var ProjectLocationCellFormatter_1 = require("../datagrid/cellFormatters/ProjectLocationCellFormatter");
var UserNameCell_1 = require("../datagrid/cellFormatters/UserNameCell");
var makeColumnFactoryParams_1 = require("../sorting/makeColumnFactoryParams");
var shouldBeObfuscated = function (_a) {
    var name = _a.name;
    return name === null;
};
function iconColumn(params) {
    var paramsOverride = __assign(__assign({}, params), { rowData: __assign(__assign({}, params.rowData), { isCertified: false }) });
    return React.createElement(data_catalog_shared_1.DatabaseMediumIcon, { database: paramsOverride.rowData });
}
function databaseGroupIcon(rowData) {
    if (!rowData.isGrouped) {
        return null;
    }
    return (React.createElement("div", { role: 'img', "aria-label": Localize_2.Messages.GroupedAsset(), title: Localize_2.Messages.GroupedAsset() },
        React.createElement(GroupPaperclip_1.SvgGroupPaperclip, null)));
}
function databaseLinkTitle(rowData) {
    return rowData.name;
}
var rowDataFunctions = {
    getAssetUrlFromRowData: function (urls, r) {
        return urls.catalogDatabaseUrl(r.id);
    },
    getNameFromRowData: function (r) {
        return r.name ? r.name : '';
    },
    getTypeNameFromRowData: function (r) { return r.__typename; },
    getDataQualityCertificationFromRowData: function (r) {
        return r.dataQualityCertifications;
    },
};
exports.columns = [
    function (sortParams) { return ({
        name: 'type',
        dataKey: globalTypes_1.DatabaseOrderField.IS_CERTIFIED,
        headerText: Localize_2.Messages.GridHeaderType(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: data_catalog_shared_1.createIconCellFormatter(function (rowData) {
            return iconColumn({
                rowData: rowData,
            });
        }, function (rowData) { return (rowData.isCertified ? '' : data_catalog_shared_1.getDatabaseIconTooltip(rowData)); }),
        sortable: true,
        resizable: false,
    }); },
    function () { return ({
        name: 'certification',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: '',
        headerTooltip: Localize_2.Messages.Certification(),
        headerFormatter: data_catalog_shared_1.DataQualityIconHeaderCertificationFormatterFactory,
        cellFormatter: data_catalog_shared_1.createDataQualityCellFormatter({
            getWarningsFromRowData: function (r) {
                return r.dataQualityWarnings;
            },
            disableIconOnlyTabIndex: true,
            isCertification: true,
            rowDataFunctions: rowDataFunctions,
        }),
        sortable: false,
        resizable: false,
    }); },
    function () { return ({
        name: 'warning',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: '',
        headerTooltip: Localize_2.Messages.DataQualityWarningTitle(),
        headerFormatter: data_catalog_shared_1.DataQualityIconHeaderFormatterFactory,
        cellFormatter: data_catalog_shared_1.createDataQualityCellFormatter({
            getWarningsFromRowData: function (r) {
                if (r.id === '') {
                    return undefined;
                }
                else {
                    return r.dataQualityWarnings;
                }
            },
            disableIconOnlyTabIndex: true,
            isCertification: false,
            rowDataFunctions: rowDataFunctions,
        }),
        sortable: false,
        resizable: false,
    }); },
    function (params) { return ({
        name: 'name',
        dataKey: globalTypes_1.DatabaseOrderField.NAME,
        headerText: Localize_2.Messages.GridHeaderName(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(params),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedLinkWithIconCellFormatter(shouldBeObfuscated, function (_a) {
            var name = _a.name;
            return name;
        }, // getTextFromRowData
        function (urls, _a) {
            var id = _a.id;
            return urls.catalogDatabasePath(id);
        }, // getPathFromRowData
        false, // noPadding,
        true, // disableTabIndex
        ObfuscatedCellFormatter_1.PermissionsRequiredCell, // ObfuscatedComponent
        databaseGroupIcon, databaseLinkTitle, function (rowData) { return rowData.id === ''; } // graphQLId
        ),
        growToFit: true,
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'virtualConnections',
        dataKey: globalTypes_1.DatabaseOrderField.DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT,
        headerText: Localize_2.Messages.GridHeaderVirtualConnection(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: data_catalog_shared_1.createTextCellFormatter(function (_a) {
            var downstreamVirtualConnectionsConnection = _a.downstreamVirtualConnectionsConnection;
            return downstreamVirtualConnectionsConnection
                ? Localize_1.Formatters.formatCount(downstreamVirtualConnectionsConnection.totalCount)
                : null;
        }),
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'workbooks',
        dataKey: globalTypes_1.DatabaseOrderField.DOWNSTREAM_WORKBOOKS_COUNT,
        headerText: Localize_2.Messages.GridHeaderWorkbooks(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: data_catalog_shared_1.createTextCellFormatter(function (_a) {
            var downstreamWorkbooksConnection = _a.downstreamWorkbooksConnection;
            return downstreamWorkbooksConnection
                ? Localize_1.Formatters.formatCount(downstreamWorkbooksConnection.totalCount)
                : null;
        }),
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'datasources',
        dataKey: globalTypes_1.DatabaseOrderField.DOWNSTREAM_DATASOURCES_COUNT,
        headerText: Localize_2.Messages.GridHeaderDatasources(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: data_catalog_shared_1.createTextCellFormatter(function (_a) {
            var downstreamDatasourcesConnection = _a.downstreamDatasourcesConnection;
            return downstreamDatasourcesConnection
                ? Localize_1.Formatters.formatCount(downstreamDatasourcesConnection.totalCount)
                : null;
        }),
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'serverOrPath',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: Localize_2.Messages.GridHeaderServerOrPath(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedTextCellFormatter(shouldBeObfuscated, data_catalog_shared_1.createServerOrPathString, undefined, // placeholder
        function (rowData) { return rowData.id === ''; }),
        resizable: true,
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'connectionType',
        dataKey: globalTypes_1.DatabaseOrderField.CONNECTION_TYPE,
        headerText: Localize_2.Messages.GridHeaderConnectionType(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedTextCellFormatter(shouldBeObfuscated, function (rowData) { return data_catalog_shared_1.messageForConnectionType(rowData.connectionType); }, undefined, // placeholder
        function (rowData) { return rowData.id === ''; }),
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'contact',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: Localize_2.Messages.GridHeaderContact(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: UserNameCell_1.createUserNameLinkCellFormatter(function (_a) {
            var contact = _a.contact;
            return contact;
        }, true, function (rowData) { return rowData.id === ''; }),
        resizable: true,
        sortable: false,
    }); },
];
/**
 * @deprecated These cell formatters are already in use in the columns above. These defs below will be removed once we have
 * the columns used properly in vpc.
 */
var cellFormattersForCrass = {
    dataQualityWarning: {
        type: 'database',
        cellFormatter: data_catalog_shared_1.createDataQualityCellFormatter({
            getWarningsFromRowData: function (r) {
                if (r.id === '') {
                    return undefined;
                }
                else {
                    return r.dataQualityWarnings;
                }
            },
            disableIconOnlyTabIndex: true,
            isCertification: false,
            rowDataFunctions: rowDataFunctions,
        }),
    },
    typeForCrass: {
        type: 'database',
        cellFormatter: data_catalog_shared_1.createIconCellFormatter(function (rowData) {
            return iconColumn({
                rowData: rowData,
            });
        }, function (rowData) { return (rowData.isCertified ? '' : data_catalog_shared_1.getDatabaseIconTooltip(rowData)); }),
    },
    name: {
        type: 'database',
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedLinkWithIconCellFormatter(shouldBeObfuscated, function (_a) {
            var name = _a.name;
            return name;
        }, // getTextFromRowData
        function (urls, _a) {
            var id = _a.id;
            return urls.catalogDatabasePath(id);
        }, // getPathFromRowData
        false, // noPadding,
        true, // disableTabIndex
        ObfuscatedCellFormatter_1.PermissionsRequiredCell, // ObfuscatedComponent
        databaseGroupIcon, databaseLinkTitle, function (rowData) { return rowData.id === ''; }),
    },
    downstreamWorkbookCount: {
        type: 'database',
        cellFormatter: data_catalog_shared_1.createTextCellFormatter(function (_a) {
            var downstreamWorkbooksConnection = _a.downstreamWorkbooksConnection;
            return downstreamWorkbooksConnection
                ? Localize_1.Formatters.formatCount(downstreamWorkbooksConnection.totalCount)
                : null;
        }),
    },
    downstreamDataSourcesCount: {
        type: 'database',
        cellFormatter: data_catalog_shared_1.createTextCellFormatter(function (_a) {
            var downstreamDatasourcesConnection = _a.downstreamDatasourcesConnection;
            return downstreamDatasourcesConnection
                ? Localize_1.Formatters.formatCount(downstreamDatasourcesConnection.totalCount)
                : null;
        }),
    },
    serverOrPath: {
        type: 'database',
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedTextCellFormatter(shouldBeObfuscated, data_catalog_shared_1.createServerOrPathString, undefined, // placeholder
        function (rowData) { return rowData.id === ''; }),
    },
    connectionTypeCrass: {
        type: 'database',
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedTextCellFormatter(shouldBeObfuscated, function (rowData) { return data_catalog_shared_1.messageForConnectionType(rowData.connectionType); }, undefined, // placeholder
        function (rowData) { return rowData.id === ''; }),
    },
    contact: {
        type: 'database',
        cellFormatter: UserNameCell_1.createUserNameLinkCellFormatter(function (_a) {
            var contact = _a.contact;
            return contact;
        }, true, function (rowData) { return rowData.id === ''; }),
    },
    databaseProjectLocation: {
        type: 'database',
        cellFormatter: ProjectLocationCellFormatter_1.createProjectLocationLinkCellFormatter(function (rowData) { return rowData.containerId === undefined ? null : rowData.containerId; }, function (rowData) { return rowData.containerName === undefined ? null : rowData.containerName; }, true, function (rowData) { return rowData.isEmbedded === undefined ? null : rowData.isEmbedded; }, function (rowData) { return rowData.id === ''; }),
    },
};
exports.columnsForVizPortal = data_catalog_shared_1.mapDC3ColumnFactoriesToVizPortalColumnFactories(exports.columns, makeColumnFactoryParams_1.makeDC3ColumnFactoryParamsFromVizPortalParams);
exports.databasesWithCrassCellFormatters = cellFormattersForCrass;
function DatabasesDisplayGrid(props) {
    var publishedConnectionsLineageEnabled = React.useContext(data_catalog_shared_1.FeatureFlagsContext).publishedConnectionsLineageEnabled;
    var cols = exports.columns
        .map(function (columnFactory) { return columnFactory(props); })
        .filter(function (column) {
        if (column.name === 'virtualConnections' && !publishedConnectionsLineageEnabled) {
            return false;
        }
        return true;
    });
    return (React.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, emptyGridMessage: props.emptyGridMessage, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.DatabasesDisplayGrid = DatabasesDisplayGrid;
//# sourceMappingURL=DatabasesDisplayGrid.js.map